// extracted by mini-css-extract-plugin
export default {"tableKpi":"index_tableKpi__V6pXm","recordHasChild":"index_recordHasChild__-SrbA","tableCellBordered":"index_tableCellBordered__rTXL2","cellLink":"index_cellLink__tDMsD"};